import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatus, formStatus, formStatuses } from '../../form.constants';
import { incentiveCategory } from '../../../project/project.constants';

@Injectable()
export class UnlockFormActionHandlerService extends FormActionHandlerService {
  constructor(
    private dataService: FormDataService,
    private statusService: FormStatusService,
    private swal: SwalService,
    private shareService: FormShareService
  ) {
    super();
  }

  private resolveUnlockTarget(): FormStatus {
    const isRd = incentiveCategory.rd.incentivePrograms.includes(
      this.shareService.currentIncentiveProgram
    );
    if (!isRd) {
      return formStatus.pending;
    }

    const transientStatuses: FormStatus[] = [
      formStatuses.pendingSignature.name,
      formStatuses.pendingPayment.name,
      formStatuses.pendingSubmit.name
    ];
    const priorSettled = this.shareService.form.statuses.find(
      status => !transientStatuses.includes(<FormStatus>status.status)
    );

    return priorSettled &&
      priorSettled.status === formStatuses.informationRequired.name
      ? formStatuses.informationRequired.name
      : formStatus.pending;
  }

  exec(): Promise<any> {
    const that = this;
    const target = this.resolveUnlockTarget();
    return new Promise((resolve, reject) => {
      this.swal
        .yesOrNo({
          title: 'Unlock this form for editing?',
          text: `If "Yes" the processing status of this form will be set back to "${target}."`
        })
        .then(() => {
          that.swal.load(`Updating form to "${target}" status...`);
          that.statusService.changeStatus(target);
          that.dataService.saveForm().subscribe(
            success => {
              that.swal
                .success({
                  title: 'Form unlocked for editing!',
                  text: "You may now make modifications to this form's details."
                })
                .then(resolve)
                .catch(resolve);
            },
            error => {
              if (error === 409) {
                reject(error);
              } else {
                reject(
                  'We are unable to update your form at this time. Please try again later.'
                );
              }
            }
          );
        })
        .catch(resolve);
    });
  }
}
